// Application entry point
import React from 'react'
import ReactDOM from 'react-dom/client'
import { App } from './App'
import './index.css'

// Force-include redesign components (prevent tree-shaking on Cloudflare)
import './components/issues/IssuesStatsBar.tsx'
import './components/issues/IssuesFilterBar.tsx'
import './components/issues/IssuesTableRow.tsx'
import './components/issues/IssuesTablePagination.tsx'
import './components/issues/IssuesEmptyState.tsx'
import './components/ui/table.tsx'

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('Root element not found')
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
